import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import './vinculo.scss'

interface Props {
  aberto: boolean
  titulo: string
  sub?: string
  children: React.ReactNode
  botao: string
  /** Botão vermelho, para tirar ou excluir. */
  perigo?: boolean
  desabilitado?: boolean
  salvando?: boolean
  erro?: string | null
  aoConfirmar: () => void
  aoFechar: () => void
}

/** Janela de formulário ou confirmação, no mesmo visual do pop-up de vínculo. */
export default function Janela({ aberto, titulo, sub, children, botao, perigo, desabilitado, salvando, erro, aoConfirmar, aoFechar }: Props) {
  if (!aberto) return null
  return (
    <div className="nv-veu" onMouseDown={e => { if (e.target === e.currentTarget && !salvando) aoFechar() }}
         onKeyDown={e => { if (e.key === 'Escape' && !salvando) aoFechar() }}>
      <div className="nv" role="dialog" aria-modal="true" aria-labelledby="nj-titulo" style={{ maxWidth: 560 }}>
        <div className="nv-cab">
          <div><h2 id="nj-titulo">{titulo}</h2>{sub && <small>{sub}</small>}</div>
          <button type="button" className="nv-ico" onClick={aoFechar} aria-label="Fechar" disabled={salvando}><CloseIcon /></button>
        </div>
        <form className="nv-corpo" onSubmit={e => { e.preventDefault(); if (!desabilitado && !salvando) aoConfirmar() }}>
          {children}
          {erro && <div className="nv-erro" role="alert">{erro}</div>}
          <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
        </form>
        <div className="nv-rodape">
          <button type="button" className="nv-btn" onClick={aoFechar} disabled={salvando}>Cancelar</button>
          <span style={{ flex: 1 }} />
          <button type="button" className="nv-btn prim" style={perigo ? { background: '#c4362b', color: '#fff' } : undefined}
                  onClick={aoConfirmar} disabled={desabilitado || salvando}>{salvando ? 'Salvando…' : botao}</button>
        </div>
      </div>
    </div>
  )
}
